<div
  *ngFor="let subform of form.controls; let i = index"
  [formGroup]="asGroup(subform)"
  class="subform-row w-100 gap-4"
>
  <ng-container [formGroup]="asGroup(subform)">
    <mat-form-field [fxFlex]="50" class="type-column">
      <app-easy-select
        [label]="'MERCHANT.TITLE.ACTIVITY_TYPE' | translate"
        formControlName="merchantType"
        [options]="merchantTypeOptions[i]"
        [labelAttribute]="'name'"
        [groupLabelAttribute]="'groupName'"
        [groupOptionsAttribute]="'options'"
        [valueAttribute]="'value'"
        [translatePrefixForSelected]="'MERCHANT.TYPE.'"
        [differentLabelWhenSelected]="true"
        [hasEmptyOption]="false"
        (ngModelChange)="rowChanged(i, true)"
      >
      </app-easy-select>
    </mat-form-field>
    <mat-form-field [fxFlex]="32">
      <app-easy-input
        formControlName="licenseNumber"
        [label]="'MERCHANT.TITLE.LICENSE_NUMBER' | translate"
        [labelInfo]="
          [
            'RETAILER_AS_HOTEL',
            'RETAILER_AS_RESTAURANT',
            'RETAILER_AS_CAFE',
            'RETAILER_AS_RETAIL_CHAIN',
            'RETAILER_AS_OTHER_RETAILER'
          ].includes(get(subform, 'merchantType')?.value)
            ? ('MERCHANT.TITLE.RETAILER_NUMBER_TOOTIP' | translate)
            : get(subform, 'merchantType')?.value ===
              'MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER'
            ? ('MERCHANT.TITLE.MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER_TOOTIP'
              | translate)
            : ''
        "
        (blurEvent)="rowChanged(i)"
      ></app-easy-input>
    </mat-form-field>

    <div
      [fxFlex]="18"
      class="d-flex gap-3 align-items-center justify-content-end status-column"
    >
      <app-status-chip
        [status]="get(subform, 'status')?.value"
      ></app-status-chip>
      <button
        class="delete-btn"
        type="button"
        mat-icon-button
        [matTooltip]="'MERCHANT.TITLE.REMOVE_ACTIVITY' | translate"
        (click)="onRemoveMerchantType(i)"
      >
        <mat-icon> delete_forever</mat-icon>
      </button>
    </div>
  </ng-container>
</div>
<!-- TODO ha már nincs több hozzáadható tevékenység -->
<button
  mat-raised-button
  type="button"
  class="bordered-button"
  (click)="addMerchantTypeRow()"
>
  {{ "MERCHANT.TITLE.ADD_ACTIVITY" | translate }}
</button>
